/**
 * Typologies de litige — source unique côté frontend.
 *
 * `transporteur` est la valeur **technique**, conservée telle quelle en base ;
 * l'utilisateur lit « Transport ». Ne pas renommer la valeur : cela imposerait
 * une migration des documents, des index, de `carrier_id`, des permissions et
 * des préfixes de numérotation, pour un gain nul — la valeur n'est jamais
 * affichée.
 */
export const TYPE_LABELS = {
  client: "Client",
  fournisseur: "Fournisseur",
  transporteur: "Transport",
  logistique_presthyg: "Logistique Prest'Hyg",
  interne: "Interne",
  autre: "Autre",
};

/** Ordre d'affichage, aligné sur `ORDRE_TYPES` du backend. */
export const TYPE_ORDER = [
  "client",
  "fournisseur",
  "transporteur",
  "logistique_presthyg",
  "interne",
  "autre",
];

/**
 * Typologies qu'un rôle a le droit de créer.
 *
 * Miroir de `backend/permissions.py`. Sert UNIQUEMENT à ne pas proposer une
 * option qui aboutirait à un 403 : le backend reste l'autorité, cette table ne
 * protège rien.
 */
const CREATION_PAR_ROLE = {
  admin: TYPE_ORDER,
  achat: TYPE_ORDER,
  logistique: TYPE_ORDER,
  responsable_qualite: TYPE_ORDER,
  direction: TYPE_ORDER,
  comptabilite: TYPE_ORDER,
  // Seule exception : le commercial n'ouvre que des litiges client.
  commercial: ["client"],
};

export function typesCreables(user) {
  const autorises = CREATION_PAR_ROLE[user?.role] || [];
  // On repasse par TYPE_ORDER pour garantir un ordre d'affichage stable.
  return TYPE_ORDER.filter((t) => autorises.includes(t));
}
